export const TIMER_REPEAT_RENTAL_CONTRACT_SIGNING =
  'timer_repeat_rental_contract_signing'
export const TIMER_REPEAT_RENTAL_CONTRACT_SIGNING_TIME = 60000
